export enum PackaginTrimsEnum {
    BAGBAGS = 'BAG-BAGS',
    BALBALES= 'BAL-BALES',
    BOTBOTTLES= 'BOT-BOTTLES',
    BOXBOXES = 'BOX-BOXES',
    CANCANPACK = 'CAN-CAN PACK',
    DRMDRUMS = 'DRM-DRUMS',
    FP1WITHOUTHANGER = 'FP1-WITHOUT HANGER',
    HP1WITHHANGER = 'HP1-WITH HANGER',
    LSELOOSEPACK = 'LSE-LOOSE PACK',
    NANOTAPPLICABLE= 'NA-NOT APPLICABLE',
    PACPACKETS= 'PAC-PACKETS',
    PLAPLATEDFORM = 'PLA-PLATED FORM',
    ROLROLLS = 'ROL-ROLLS',
    SPKSPECIALPACK = 'SPK-SPECIAL PACK',
    STDSTDPACK = 'STD-STD PACK',
    STPSTANDPACK = 'STP-STAND PACK',
    VPKVACCUMPACKING = 'VPK-VACCUM PACKING',
    WOPWOODENPACKED = 'WOP-WOODEN PACKED'

}
